import axios from "axios";

const axiosInstance = axios.create({
    timeout: 30000,
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

axiosInstance.interceptors.request.use(
    res => {
        if (res && !res.ignoreLoading) {
            window.loadingPublisher.add();
        }
        return res;
    }, error => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        if (response && response?.config && !response?.config?.ignoreLoading) {
            window.loadingPublisher.sub();
        }
        return response?.data;
    },
    (error) => {
        window.loadingPublisher.sub();
        const expectedError = error.response && error.response.status >= 400 && error.response.status <= 600;
        if (expectedError) {
            window.jroAlert.error(error?.response?.data?.Message);
            return Promise.resolve(error.response.data);
        }

        return Promise.resolve(error);
    }
);

export default axiosInstance;
